export default __webpack_public_path__ + "static/media/bg-login.81dd1711.webp";